// extracted by mini-css-extract-plugin
module.exports = {"list":"dd31006766--list--cXO1f"};